import miniToastr from 'mini-toastr';

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
};

miniToastr.init({ types: toastTypes });

miniToastr.setIcon('error', 'i', { class: 'icon-close' });
miniToastr.setIcon('info', 'i', { class: 'icon-info' });
miniToastr.setIcon('success', 'i', { class: 'icon-check' });
miniToastr.setIcon('warn', 'i', { class: 'icon-flag' });

export default function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}
